import React, { useEffect, useMemo, useState } from "react";
import { API_URL } from "../auth";
import MobileScrollArea from "./MobileScrollArea";

export default function SuppressionPage() {
  const [rows, setRows] = useState([]);
  const [email, setEmail] = useState("");
  const [reason, setReason] = useState("manual");
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  async function load() {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/suppressions`);
      const data = await res.json().catch(() => []);
      if (!res.ok) throw new Error(data.message || "Could not load suppression list.");
      setRows(Array.isArray(data) ? data : []);
      setMessage("");
    } catch (err) { setMessage(err.message); }
    finally { setLoading(false); }
  }
  useEffect(() => { load(); }, []);

  async function add(e) {
    e.preventDefault();
    if (!email.trim()) return;
    const res = await fetch(`${API_URL}/api/suppressions`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email: email.trim(), reason }) });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) return setMessage(data.message || "Could not suppress address.");
    setEmail("");
    await load();
  }

  async function remove(id) {
    if (!window.confirm("Allow sending to this address again?")) return;
    const res = await fetch(`${API_URL}/api/suppressions/${id}`, { method: "DELETE" });
    if (res.ok) setRows((current) => current.filter((row) => row._id !== id));
  }

  const visible = useMemo(() => {
    const q = query.trim().toLowerCase();
    return q ? rows.filter((row) => `${row.email} ${row.reason} ${row.source}`.toLowerCase().includes(q)) : rows;
  }, [rows, query]);

  return <section className="sx-suppress-page">
    <header className="sx-suppress-head"><div><h2>Suppression List</h2><p>Hard bounces, complaints, unsubscribes and manually blocked addresses are never sent another campaign.</p></div><button type="button" className="sx-admin-refresh" onClick={load}>Refresh</button></header>
    <form className="sx-suppress-form" onSubmit={add}>
      <label><span>Email address</span><input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="blocked@example.com" required /></label>
      <label><span>Reason</span><select value={reason} onChange={(e) => setReason(e.target.value)}><option value="manual">Manual</option><option value="unsubscribe">Unsubscribe</option><option value="hard_bounce">Hard bounce</option><option value="complaint">Spam complaint</option></select></label>
      <button type="submit" className="yellow-btn">Suppress address</button>
    </form>
    {message ? <div className="sx-suppress-message">{message}</div> : null}
    <div className="sx-suppress-toolbar"><input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search suppressed addresses…" /><span>{visible.length} addresses</span></div>
    <MobileScrollArea className="sx-suppress-table-wrap" ariaLabel="suppression table"><table className="sx-suppress-table"><thead><tr><th>Email</th><th>Reason</th><th>Source</th><th>Updated</th><th></th></tr></thead><tbody>
      {!loading && visible.length === 0 ? <tr><td colSpan="5" className="sx-suppress-empty">No suppressed addresses.</td></tr> : null}
      {visible.map((row) => <tr key={row._id}><td data-label="Email">{row.email}</td><td data-label="Reason"><span className={`sx-suppress-badge ${row.reason}`}>{String(row.reason || "manual").replaceAll("_", " ")}</span></td><td data-label="Source">{row.source || "manual"}</td><td data-label="Updated">{new Date(row.updatedAt || row.lastEventAt).toLocaleString()}</td><td><button type="button" className="sx-link-btn sx-danger" onClick={() => remove(row._id)}>Remove</button></td></tr>)}
    </tbody></table></MobileScrollArea>
  </section>;
}
